import $ from "jquery";

const ebook = $('.js-ebook');
const section_bg = $('.js-section-bg');
const form = $('.workshop__card-form');
const message = $('.js-workshop-message');
const workshop_container = $('.js-workshop-container');
const card_full_width = $('.workshop__card-item--full');
const image_container = $('.js-whats-inside-image-slider');

function getImageHeight() {
    let image_height = image_container.outerHeight() / 2;
    section_bg.css({'height': 'calc(100% + '+image_height+'px)', 'margin-top':'-'+image_height+'px'});
}

$(window).on('load', function(){
    getImageHeight();
});

$(window).on('resize', function(){
    setTimeout(function() {
        getImageHeight();
    }, 500)
});

ebook.on('click', function() {
    form.fadeToggle();
    card_full_width.addClass('is-active');
    $(this).removeClass('d-inline-flex').addClass('d-none');
});

document.querySelector('.workshop__card-form form').addEventListener('wpcf7mailsent', function(event) {
    message.removeClass('d-none');
    workshop_container.addClass('d-none');
    card_full_width.removeClass('is-active');    
}, false);